export default __webpack_public_path__ + "static/media/button_goback_vi.1a4f2bc3.svg";